import "./Rotation.css";
import "../../Subbundle.css";
import React from "react";
import { Link } from "react-router-dom";
import LeftRotationCode from "../../../../Images/left-rotation-code.PNG";
import RightRotationCode from "../../../../Images/right-rotation-code.PNG";

class Block extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			blockValue: Math.floor(Math.random() * 100),
			count: 1,
			bgColor: "#27b6f8",
			blockId: this.props.id,
			blockClicked: 0
		};
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		if (this.state.blockClicked == 0) {
			selectedBlockValue = this.state.blockValue;
			this.setState({ blockClicked: 1 });
		} else {

		}
	}

	render() {
		return (
			<div
				style={{ backgroundColor: this.state.bgColor }}
				id={this.props.id}
				className="rot-block"
				onClick={this.handleClick}
			>
				<p>{this.state.blockValue}</p>
			</div>
		);
	}
}

let arr = [];
let selectedBlockValue = 0;

for (let i = 0; i < 10; i++) {
	arr.push(<Block id={"rot_" + String(i)} />);
}

// arrayRotate rotates array to the left by default
function arrayRotate(arr, reverse) {
	if (reverse) arr.unshift(arr.pop());
	else arr.push(arr.shift());
	return arr;
}

class Rotation extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			count: 1,
		};
		this.incrementCount = this.incrementCount.bind(this);
		this.decrementCount = this.decrementCount.bind(this);
		this.leftRotation = this.leftRotation.bind(this);
		this.rightRotation = this.rightRotation.bind(this);
	}

	componentDidMount() {
		document.title = "Array Rotation | Array Bundle";
		window.scroll(0, 0);
	}

	incrementCount() {
		this.setState({ count: this.state.count + 1 });
	}
	decrementCount() {
		if (this.state.count - 1 == 0) {
			alert("Minimum value should be 1");
		} else {
			this.setState({ count: this.state.count - 1 });
		}
	}
	leftRotation() {
		let list = [];
		for (let i = 0; i < 10; i++) {
			list.push(document.getElementById("rot_" + String(i)).innerText);
		}
		for (let i = 0; i < this.state.count; i++) {
			list = arrayRotate(list, false);
		}
		for (let i = 0; i < 10; i++) {
			document.getElementById("rot_" + String(i)).innerText = list[i];
		}
		for (let i = 0; i < 10; i++) {
			let elem = document.getElementById("rot_" + String(i));
			if (elem.innerText == String(selectedBlockValue)) {
				elem.style.backgroundColor = "#f12693";
			} else {
				elem.style.backgroundColor = "rgb(39, 182, 248)";
			}
		}
	}
	rightRotation() {
		let list = [];
		for (let i = 0; i < 10; i++) {
			list.push(document.getElementById("rot_" + String(i)).innerText);
		}
		for (let i = 0; i < this.state.count; i++) {
			list = arrayRotate(list, true);
		}
		for (let i = 0; i < 10; i++) {
			document.getElementById("rot_" + String(i)).innerText = list[i];
		}
		for (let i = 0; i < 10; i++) {
			let elem = document.getElementById("rot_" + String(i));
			if (elem.innerText == String(selectedBlockValue)) {
				elem.style.backgroundColor = "#f12693";
			} else {
				elem.style.backgroundColor = "rgb(39, 182, 248)";
			}
		}
	}

	render() {
		return (
			<div className="subbundle-main">
				<h1 style={{textAlign: 'center', fontFamily: 'Gilroy', textDecoration: 'underline', fontSize: '2rem'}}><Link to="/">Go to Home</Link></h1>
				<h1>Array Rotation</h1>
				<p>
					The rotation of an array simply means to shift the array
					elements of an array to the specified positions. We can
					rotate an array in both directions i.e.{" "}
					<b>clockwise (right) and anti-clockwise (left)</b>. We can
					perform any number of rotations on an array.
				</p>
				<p>
					In left rotation, the array elements rotated to the left
					with the specified number of positions. It rotates the array
					in the clockwise direction. The lowest index element moves
					to the highest index in rotation.
				</p>
				<img
					style={{ backgroundColor: "white" }}
					src="https://static.javatpoint.com/core/images/array-rotation-in-java.png"
				/>
				<p>Let's look at the code implementation in Python:</p>
				<img style={{ width: "50%" }} src={LeftRotationCode} />
				<p>
					In the right rotation, the array elements rotated to the
					right with the specified number of positions. It rotates the
					array in an anti-clockwise direction.
				</p>
				<img
					style={{ backgroundColor: "white" }}
					src="https://static.javatpoint.com/core/images/array-rotation-in-java3.png"
				/>
				<p>Let's look at the code implementation in Python:</p>
				<img style={{ width: "50%" }} src={RightRotationCode} />
				<p>
					To demonstrate array rotation below, we rotate elements one
					by one in our Javascript implementation of rotation of an
					array, just like we did in the Python code screenshots
					above.
				</p>
				<hr />
				<h1>GAME TIME!</h1>
				<div className="subbundle-game-container">
					<h1 style={{ textAlign: "center", fontFamily: "Poppins" }}>
						Select a number and either choose left rotation or right
						rotation.
					</h1>
					<div className="rot">{arr}</div>
					<div className="rot-specs">
						<div className="rot-specs-left">
							<h1 className="ctrl-button">{this.state.count}</h1>
							<div
								onClick={this.incrementCount}
								className="ctrl-button incr-count"
							>
								INC
							</div>
							<div
								onClick={this.decrementCount}
								className="ctrl-button decr-count"
							>
								DEC
							</div>
						</div>
						<div className="rot-specs-right">
							<div
								onClick={this.leftRotation}
								className="ctrl-button left-rotation"
							>
								{"<<"}
							</div>
							<div
								onClick={this.rightRotation}
								className="ctrl-button right-rotation"
							>
								{">>"}
							</div>
						</div>
					</div>
				</div>
				<div className="next-previous-div">
					<Link to="/games/arrays/addressing">
						<span>
							{"<"}Prev <b>Addressing in Arrays</b>
						</span>
					</Link>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<Link to="/games/arrays/insertion">
						<span>
							Next{">"} <b>Insertion in Arrays</b>
						</span>
					</Link>
				</div>
			</div>
		);
	}
}

export default Rotation;
